<template>
    <div
        class="flex flex-col mx-auto p-6 max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow xl:p-8 mt-4 mb-6">
        <h3 class="mb-4 text-2xl font-semibold break-words">
            {{ content.title }}
        </h3>
        <p class="font-light text-gray-500 sm:text-lg">
            {{ content.subtitle }}
        </p>
        <div class="flex justify-center items-baseline my-8">
            <span class="mr-2 text-5xl font-extrabold">
                €{{ content.price }}
            </span>
        </div>
        <ul v-if="content.points" role="list" class="mb-8 space-y-4 text-left">
            <li v-for="point in content.points" :key="point.id" class="flex items-center space-x-3">
                <svg class="flex-shrink-0 w-5 h-5 text-green-500" fill="currentColor"
                    viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"></path>
                </svg>
                <span>{{ point }}</span>
            </li>
        </ul>
        <a v-if="content.button.text" type="button" :href="content.button.link"
            class="button">
            {{ content.button.text }}
        </a>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    content: {
        type: Object,
        required: true
    }
})
</script>